import HttpClient from "../HttpClient"

const bffKey = process.env.REACT_APP_BFF_KEY || process.env.BFF_KEY

// O zelas-bff nao valida Authorization (so CORS); o header so vai quando a
// chave existir, para nao quebrar BFFs que ainda exigem.
const buildHeaders = (): Record<string, string> => {
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    origin: window.location.origin
  }

  if (bffKey) headers.authorization = bffKey

  return headers
}

class BFFService {
  httpClient: HttpClient

  constructor(baseUrl = '') {
    this.httpClient = new HttpClient(baseUrl)
  }

  async sendData (data: Record<string, unknown>) {
    const endpoint =
      process.env.REACT_APP_BFF_ENDPOINT ||
      process.env.BFF_ENDPOINT ||
      'https://api-zelas.hubchat.com.br'

    return await fetch(endpoint, {
      method: 'POST',
      body: JSON.stringify({
        query: `
          mutation SaveLead($leadData: LeadData!, $leadId: String, $from: LeadApps!) {
            saveLead(leadData: $leadData, leadId: $leadId, from: $from) {
              leadId
              error
            }
          }
        `,
        variables: {
          leadData: {
            ...data
          },
          from: 'FORMS_ZELAS'
        }
      }),
      headers: buildHeaders()
    })
  }
}

export default BFFService
